import Flickity from 'react-flickity-component'


function StyledFlickity({ flickityOptions, flickityStyle, flickityContent }) {
    return (
        <Flickity
            className={flickityStyle}
            elementType={'div'}
            options={flickityOptions}
            disableImagesLoaded
            reloadOnUpdate
            static
        >
          {flickityContent}
        </Flickity>
    );
}
export default StyledFlickity;